import React from 'react';
import { DangerButton } from '../../../../../../healtheraComponents';
import { Questionnaire } from '../../../../types';
import { useIsQuestionnaireAttached } from '../../../hooks/useIsQuestionnaireAttached';
import { useDeleteQuestionnaire } from '../hooks/useDeleteQuestionnaire';

interface Props {
  questionnaire: Questionnaire;
}

const DeleteButton = ({ questionnaire }: Props) => {
  const deleteQuestionnaire = useDeleteQuestionnaire(questionnaire);
  const { isAttached, isLoading } = useIsQuestionnaireAttached(questionnaire._id ? String(questionnaire._id) : null);

  const handleDelete = () => {
    if (isLoading) return;

    if (isAttached) {
      alert('This questionnaire is currently attached to a condition. You cannot delete it.');
      return;
    }

    deleteQuestionnaire();
  };

  return <DangerButton onClick={handleDelete}>{questionnaire._id ? 'Delete' : 'Cancel'}</DangerButton>;
};

export default DeleteButton;
